import { render, staticRenderFns } from "./home.vue?vue&type=template&id=a841daf6&scoped=true&"
var script = {}
import style0 from "./home.vue?vue&type=style&index=0&id=a841daf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a841daf6",
  null
  
)

export default component.exports